export default "__VITE_ASSET__4b70a458__"